import { boolean, object, string } from 'yup';

export const RequestTransportInsurance = object({
    licencePlate: string()
        .min(5, 'eshop.transport.validation.invalidLicencePlate')
        .required('profile.validation.fieldRequired'),
    personalCode: string()
        .min(1, 'eshop.transport.validation.invalidPersonalCode')
        .required('profile.validation.fieldRequired'),
    acceptPrivacyPolicy: boolean()
        .is([true], 'eshop.transport.validation.mustAcceptPrivacyPolicy')
        .required('profile.validation.fieldRequired'),
});
